import React from "react";
import AdminAddGallery from "../../Components/Admin/AdminAddGallery";
import SideBar from "../../Components/Admin/SideBar";

const AdminAddGalleryPage = ()=>{
    return (
      <AdminAddGallery />
    )
}

export default AdminAddGalleryPage;